// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,400;0,700;1,400;1,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: inherit;
}

html {
  box-sizing: border-box;
  font-size: 62.5%;
  /* 1rem = 10px the html fontsize determines the value of one rem */
}
@media only screen and (max-width: 81.25em) {
  html {
    font-size: 56.25%;
  }
}
@media only screen and (max-width: 75em) {
  html {
    font-size: 50%;
  }
}
@media only screen and (max-width: 22 5em) {
  html {
    font-size: 37.5%;
  }
}

body {
  background-color: var(--color-white);
  background-size: cover;
  background-repeat: no-repeat;
  font-family: "Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  font-weight: 400;
  font-size: var(--default-font-size);
  line-height: 2.2rem;
  color: var(--color-dark);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", "Montserrat", monospace;
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAGA;;;EAGC,SAAA;EACA,UAAA;EACA,mBAAA;AADD;;AAGA;EACC,sBAAA;EACA,gBAAA;EAEA,kEAAA;AADD;AAGC;EAND;IAOE,iBAAA;EAAA;AACF;AAEC;EAVD;IAWE,cAAA;EACA;AACF;AACC;EAdD;IAeE,gBAAA;EAEA;AACF;;AACA;EACC,oCAAA;EACA,sBAAA;EACA,4BAAA;EACA,4KAAA;EAGA,gBAAA;EACA,mCAAA;EACA,mBAAA;EACA,wBAAA;EAEA,mCAAA;EACA,kCAAA;EAEA,iBAAA;AAFD;;AAKA;EACC,6FAAA;AAFD","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,400;0,700;1,400;1,700&display=swap');\n@import './assets/styles/variables/breakpoints';\n\n*,\n*::before,\n*::after {\n\tmargin: 0;\n\tpadding: 0;\n\tbox-sizing: inherit;\n}\nhtml {\n\tbox-sizing: border-box;\n\tfont-size: 62.5%;\t\n\n\t/* 1rem = 10px the html fontsize determines the value of one rem */\n\n\t@media only screen and (max-width: $bp-xxl) {\n\t\tfont-size: 56.25%; //1rem becomes 9px.\n\t}\n\n\t@media only screen and (max-width: $bp-largest) {\n\t\tfont-size: 50%; //1rem becomes 8px.\n\t}\n\n\t@media only screen and (max-width: $bp-xxs) {\n\t\tfont-size: 37.5%; //1rem becomes 6px.\n\t}\n}\n\nbody {\n\tbackground-color: var(--color-white);\n\tbackground-size: cover;\n\tbackground-repeat: no-repeat;\n\tfont-family: 'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI',\n\t\t'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',\n\t\t'Helvetica Neue', sans-serif;\n\tfont-weight: 400;\n\tfont-size: var(--default-font-size);\n\tline-height: 2.2rem;\n\tcolor: var(--color-dark);\n\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n\n\tmin-height: 100vh;\n}\n\ncode {\n\tfont-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', 'Montserrat',\n\t\tmonospace;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
